import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "separator my-4"
}
const _hoisted_2 = {
  key: 1,
  class: "mb-5"
}

import { computed } from 'vue'
  import { useI18n } from 'vue-i18n'

  // UI Components
  import BookingPlaceholder from '@/components/ConfirmedReservations/BookingPlaceholder.vue'
  import Booking from '@/components/common/Booking.vue'
  import EurostarTicketsBox from '@/components/common/EurostarTicketsBox.vue'
  import PageSection from '@/components/UI/PageSection.vue'

  // Icons
  import SlopesIcon from '@/assets/SlopesIcon.vue'

  // Types
  import { BookingSummary } from '@/services/BookingService.interface'
  import { BookingStatus } from '@/config'
  import { useBookingStatus } from '@/composables/useBookingStatus'
  import { useStore } from '@/store'
  import { getEurostarDisplayForBookings } from '@/utils/eurostarTickets'

  // Props
  
export default /*@__PURE__*/_defineComponent({
  __name: 'BookingList',
  props: {
    bookings: {
      type: Array as () => BookingSummary[],
      required: true,
      default: () => [],
    },
    emptyTitleKey: {
      type: String,
      default: 'reservations.noBooking',
    },
    emptyDescriptionKey: {
      type: String,
      default: 'reservations.timeToChoose',
    },
  },
  setup(__props) {

  const props = __props

  // Translation
  const { t } = useI18n()
  const store = useStore()

  // Computed: Check if there are bookings with "Reservation" status
  const hasReservationStatus = computed(() =>
    props.bookings.some(booking => booking.status === BookingStatus.Reservation)
  )

  // Computed: Sort bookings by appropriate date based on status
  const sortedBookings = computed(() => {
    return [...props.bookings].sort((a, b) => {
      const aStatus = useBookingStatus(a)
      const bStatus = useBookingStatus(b)

      // For reservations, use createDate
      if (aStatus.isReservationStatus.value && bStatus.isReservationStatus.value) {
        const dateA = new Date(a.createDate ?? 0).getTime()
        const dateB = new Date(b.createDate ?? 0).getTime()
        return dateB - dateA
      }
      // For quotes and cart in progress, use createVersionDate
      if (aStatus.isQuoteOrCartInProgress.value && bStatus.isQuoteOrCartInProgress.value) {
        const dateA = new Date(a.createVersionDate).getTime()
        const dateB = new Date(b.createVersionDate).getTime()
        return dateB - dateA
      }
      // Keep original order for mixed statuses
      return 0
    })
  })

  const eurostarDisplay = computed(() =>
    getEurostarDisplayForBookings(
      sortedBookings.value,
      store.getters.getLocale
    )
  )

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(PageSection, {
      title: _unref(t)('reservations.nextStay'),
      "display-title": hasReservationStatus.value
    }, {
      default: _withCtx(() => [
        (!__props.bookings?.length)
          ? (_openBlock(), _createBlock(BookingPlaceholder, {
              key: 0,
              "title-key": __props.emptyTitleKey,
              "description-key": __props.emptyDescriptionKey
            }, {
              icon: _withCtx(() => [
                _createVNode(SlopesIcon)
              ]),
              _: 1
            }, 8, ["title-key", "description-key"]))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sortedBookings.value, (booking, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: booking.reference
                }, [
                  _createVNode(Booking, { booking: booking }, null, 8, ["booking"]),
                  (index < sortedBookings.value.length - 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_2))
                ]))
              }), 128)),
              (eurostarDisplay.value)
                ? (_openBlock(), _createBlock(EurostarTicketsBox, {
                    key: 0,
                    reference: eurostarDisplay.value.reference,
                    class: "mt-2 mb-4"
                  }, null, 8, ["reference"]))
                : _createCommentVNode("", true)
            ], 64))
      ]),
      _: 1
    }, 8, ["title", "display-title"])
  ]))
}
}

})